import "core-js/modules/es.array.push.js";
export default {
  props: {
    title: {
      type: Boolean,
      default: true
    },
    byline: {
      type: Boolean,
      default: false
    },
    portrait: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    params() {
      let vals = [];
      if (!this.title) vals.push("title=0");
      if (!this.byline) vals.push("byline=0");
      if (!this.portrait) vals.push("portrait=0");
      return vals.join("&");
    }
  }
};